// The Panel's axios auth handling (authHttp.js: base URL, bearer header, refresh on 401) is loaded on demand, not
// with the entry bundle: the public pages never use axios (docs/cloud/reports/public-mobile-lcp.md). Every route
// that does use it waits for it (lazyWithI18n in lib/lazyRetry.js), and App.js loads it before checking a stored
// session. App.js puts its state setters in authHandlers; authHttp.js calls them when a refresh renews or ends
// the session.
export const authHandlers = { onRefreshed: () => {}, onSignedOut: () => {} };

let pending = null;
let loaded = null;

export function loadAuthHttp() {
  if (!pending) {
    pending = import("./authHttp").then((http) => {
      http.installAuthHttp(authHandlers);
      loaded = http;
      return http;
    });
    // a failed load (flaky connection) may be retried by the next caller
    pending.catch(() => {
      pending = null;
    });
  }
  return pending;
}

// The module once loaded, or null: there is no bearer header to clear before it has ever been loaded.
export function loadedAuthHttp() {
  return loaded;
}
